export const trigger = (url: string, token: string, name: string) => {
    fetch(`${url}/trigger/${name}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-centreblock-consumer-token': token,
        },
    }).catch(console.error)
}
